export const UploadGraphics = () => {
  return (
    <svg width="109" height="108" viewBox="0 0 109 108" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="108" height="108" fill="white" fillOpacity="0.01" />
      <rect
        x="34.3553"
        y="8.20923"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        transform="rotate(10 34.3553 8.20923)"
        fill="url(#paint0_linear_1129_17186)"
      />
      <rect
        x="27.6323"
        y="7.5"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        transform="rotate(5 27.6323 7.5)"
        fill="url(#paint1_linear_1129_17186)"
      />
      <rect
        x="20.4542"
        y="7.58911"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        fill="white"
        stroke="#E2E8F0"
        strokeWidth="1.16985"
        strokeLinecap="square"
      />
      <circle cx="56" cy="51" r="14.25" stroke="#2563EB" strokeWidth="1.5" />
      <path
        d="M62 53V55.6667C62 56.0203 61.8595 56.3594 61.6095 56.6095C61.3594 56.8595 61.0203 57 60.6667 57H51.3333C50.9797 57 50.6406 56.8595 50.3905 56.6095C50.1405 56.3594 50 56.0203 50 55.6667V53"
        stroke="#2563EB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.3333 48.3333L56 45L52.6666 48.3333"
        stroke="#2563EB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M56 45V53" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient
          id="paint0_linear_1129_17186"
          x1="34.3553"
          y1="8.20923"
          x2="34.3553"
          y2="90.8787"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0045D7" />
          <stop offset="1" stopColor="#195DEE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1129_17186"
          x1="-6.81328"
          y1="48.8347"
          x2="74.5009"
          y2="116.597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98B9FF" />
          <stop offset="1" stopColor="#195DEE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
